import { useUserContext } from "@/context/user.context";
import { LAYOUT_DIMENSIONS } from "@/utils/ui";

export const useImpersonationBannerHeight = () => {
  const { user } = useUserContext();

  return user?.isInternal
    ? LAYOUT_DIMENSIONS.IMPERSONATION_BANNER_HEIGHT_PX
    : 0;
};
